import { render, staticRenderFns } from "./SectionAbout.vue?vue&type=template&id=1e8625d4&scoped=true"
import script from "./SectionAbout.vue?vue&type=script&lang=js"
export * from "./SectionAbout.vue?vue&type=script&lang=js"
import style0 from "./SectionAbout.vue?vue&type=style&index=0&id=1e8625d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8625d4",
  null
  
)

export default component.exports